import { MenuItemWithQuantity } from '@/app/store';
import { MenuItemWeightDto, WeightUnits } from '@/app/store/api/restApi';

const toKg = (weight: MenuItemWeightDto | null | undefined): number => {
  if (!weight) return 0;
  return weight.units === WeightUnits.Kilogram ? weight.value : weight.value / 1000;
};

/**
 * Total weight of the cart in kilograms.
 * - Items listed in `unavailableProductIds` are excluded.
 * - Variant weight overrides the parent item weight (backend fallback rule:
 *   variant first, then menu item). Missing weight counts as 0.
 */
export const getCartTotalWeightKg = (
  menuItems: MenuItemWithQuantity[],
  unavailableProductIds?: string[],
): number => {
  const available = unavailableProductIds
    ? menuItems.filter((mi) => !unavailableProductIds.includes(mi.product.id))
    : menuItems;

  const total = available.reduce((sum, mi) => {
    if (mi.variants && mi.variants.length > 0) {
      return (
        sum +
        mi.variants.reduce((vSum, v) => vSum + toKg(v.value.weight ?? mi.product.weight) * v.quantity, 0)
      );
    }
    return sum + toKg(mi.product.weight) * mi.quantity;
  }, 0);

  return total;
};
